export const AUTH_ROUTES = {
  LOGIN: '/login',
  SIGNIN: '/signin',
  PROVIDER_LOGIN: '/provider/login',
  PROVIDER_SIGNIN: '/provider/signin',
  EMAIL_VERIFICATION: '/email-verification',
  NEW_PASSWORD: '/new-password',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY: '/verify/:verifyId',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_ROUTE: '/reset-password/:verifyId',
  MFA_VERIFICATION: '/mfa-verification',
  SMS_MFA_VERIFICATION: '/sms-mfa-verification',
};

export const VENDOR_ROUTES = {
  HOME: '/requests',
  ONBOARDING: '/onboarding',
  WORK_ORDERS: '/work-orders',
};

export const COORDINATOR_ROUTES = {
  HOME: '/work-queues',
  /**
   * The dashboard. Unlike `HOME` it names no module: it resolves client-side to
   * the user's FIRST PERMITTED module, so it is the safe landing spot for a
   * redirect that cannot assume the user holds any particular permission — which
   * is exactly the case for `FlagGatedRoute`'s flag-off redirect.
   */
  DASHBOARD: '/',
  SERVICE_REQUEST: '/service-requests',
  WORK_ORDERS: '/work-orders',
  PROPERTIES: '/properties',
  PROPERTY_DETAILS: '/properties/:id',
  SETTINGS: '/settings',
  MARKETS_SETTINGS: '/settings/markets',
  MARKETS_CREATE: '/settings/markets/new',
  MARKETS_DETAIL: '/settings/markets/:id',
  VENDOR_PRIORITIZATION: '/settings/vendor-prioritization',
  SETTINGS_USERS: '/settings/users',
  /**
   * The revamped user details page. Defined here once and built through
   * `buildSettingsUserDetailsUrl` so no call site spells the path out itself.
   */
  SETTINGS_USER_DETAILS: '/settings/users/:userId',
  /** The revamped "add a user" page — the create form that replaces the invite-user modal. */
  SETTINGS_USER_NEW: '/settings/users/new',
  /** The revamped "add a role" page. Defined here once and built through `buildSettingsRoleNewUrl`. */
  SETTINGS_ROLE_NEW: '/settings/users/roles/new',
  /** The revamped role editor. Defined here once and built through `buildSettingsRoleDetailsUrl`. */
  SETTINGS_ROLE_DETAILS: '/settings/users/roles/:roleId',
};

/** Style guide (design system) routes. Use for redirects and Link href. */
export const STYLE_GUIDE_ROUTES = {
  ROOT: '/style-guide',
  FOUNDATIONS: {
    ROOT: '/style-guide/foundations',
    DEFAULT: '/style-guide/foundations/color-palette',
    COLOR_PALETTE: '/style-guide/foundations/color-palette',
    BORDER_RADIUS: '/style-guide/foundations/border-radius',
    BOX_SHADOW: '/style-guide/foundations/box-shadow',
    SPACING: '/style-guide/foundations/spacing',
    SIZE: '/style-guide/foundations/size',
    ICONS: '/style-guide/foundations/icons',
    LOGOS: '/style-guide/foundations/logos',
    TYPOGRAPHY: '/style-guide/foundations/typography',
  },
  BASE_COMPONENTS: {
    ROOT: '/style-guide/base-components',
    DEFAULT: '/style-guide/base-components/accordion',
    ACCORDION: '/style-guide/base-components/accordion',
    ALERTS: '/style-guide/base-components/alerts',
    AVATARS: '/style-guide/base-components/avatars',
    BADGES: '/style-guide/base-components/badges',
    BREADCRUMB: '/style-guide/base-components/breadcrumb',
    BUTTONS: '/style-guide/base-components/buttons',
    DATE_SELECTORS: '/style-guide/base-components/date-selectors',
    CHECKBOX: '/style-guide/base-components/checkbox',
    CHIP: '/style-guide/base-components/chip',
    CURSOR: '/style-guide/base-components/cursor',
    DIVIDERS: '/style-guide/base-components/dividers',
    FILE_UPLOAD: '/style-guide/base-components/file-upload',
    INPUT: '/style-guide/base-components/input',
    INFO: '/style-guide/base-components/info',
    PROGRESSBARS: '/style-guide/base-components/progressbars',
    RADIO: '/style-guide/base-components/radio',
    SCROLLBAR: '/style-guide/base-components/scrollbar',
    SKELETON: '/style-guide/base-components/skeleton',
    TABS: '/style-guide/base-components/tabs',
    TABLES: '/style-guide/base-components/tables',
    TAGS: '/style-guide/base-components/tags',
    TOASTS: '/style-guide/base-components/toasts',
    TOGGLES: '/style-guide/base-components/toggles',
    TOOL_TIPS: '/style-guide/base-components/tool-tips',
    RANGE_SLIDER: '/style-guide/base-components/range-slider',
  },
} as const;

export const OPEN_SIDE_PANEL_ROUTES = [
  'work-orders',
  'quotes',
  'users',
  'calendar',
  'settings',
  'profile',
  'vendors',
  'service-requests',
  'work-queues',
  'scheduling',
  // ORI-166: Property Detail → Service Requests tab opens the existing SR
  // side panel via ?srId=<uuid>; UnifiedSidePanel only mounts on routes that
  // appear here, so the property detail path must be included for row clicks
  // and deep links on the SR tab to work.
  'properties',
];

const ROUTES = {
  // Coordinator routes
  COORDINATOR_HOMEPAGE: '/work-queues',
  // Vendor routes
  VENDOR_HOMEPAGE: '/requests',
};

export default ROUTES;
